import React, { useRef, useState } from "react";
import { Alert, Button, Card, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useAuth } from "../../contexts/AuthContext";
import { getAuthErrorMessage } from "../../util/authErrors";

const RecoveryContainer = styled.main`
  box-sizing: border-box;
  margin: 100px auto 32px;
  max-width: 440px;
  padding: 0 20px;
  width: 100%;
`;

const RecoveryCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
`;

export default function ForgotPassword() {
  const emailRef = useRef();
  const { resetPassword } = useAuth();
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      await resetPassword(emailRef.current.value);
      setMessage("If an account exists for that email, a password-reset link is on its way.");
    } catch (authError) {
      setError(getAuthErrorMessage(authError, "We could not send the reset email. Please try again."));
    } finally {
      setLoading(false);
    }
  }

  return (
    <RecoveryContainer>
      <RecoveryCard>
        <Card.Body>
          <h1 className="h3 text-center mb-3">Reset your password</h1>
          <p className="text-muted text-center">
            Enter your account email and we’ll send you a secure reset link.
          </p>
          {error && <Alert variant="danger">{error}</Alert>}
          {message && <Alert variant="success">{message}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="recovery-email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" ref={emailRef} required autoFocus />
            </Form.Group>
            <Button disabled={loading} className="w-100" type="submit">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </Form>
        </Card.Body>
      </RecoveryCard>
      <div className="text-center mt-3">
        <Link to="/login">Back to login</Link>
      </div>
    </RecoveryContainer>
  );
}
